import React, { useState, useEffect } from 'react';
import { ISearchParamsAware } from './ISearchParams';
import { useDebounce } from '../utils';

const TermSearch: React.FC<ISearchParamsAware> = props => {

    const { searchParams, setSearchParams } = props
    const [currentSearch, setCurrentSearch] = useState(searchParams.query)
    const debouncedSearchTerm = useDebounce(currentSearch, 1000)

    const updateParams = () => {
        const newParams = {...searchParams}
        newParams.query = currentSearch
        newParams.offset = 0

        setSearchParams(newParams)
    }

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            updateParams()
        }
    }

    useEffect(() => {
        if (currentSearch !== searchParams.query)
            updateParams()
        }, [debouncedSearchTerm]
    )

    return (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text" id="search-addon">
                    <i className="fa fa-search"></i>
                </span>
            </div>
            <input
                type="text"
                className="col-md-2 col-sm-4 col-xs-6 form-control"
                aria-describedby="search-addon"
                data-cy="input-term-search"
                onKeyPress={e => handleKeyPress(e)}
                onChange={e => setCurrentSearch(e.target.value)}
            >
            </input>
        </div>
    );
}

export default TermSearch;
